export const getOptions = () => {
  return {
    vpp: [
      {
        value: "8ecaf804-e7ff-11ee-b5de-025e9f07eba1",
        label: "Evergen",
      },
    ],
    retailer: [
      {
        value: "923d09fe-e7ff-11ee-b5de-025e9f07eba1",
        label: "1st Energy",
      },
      {
        value: "923d0a52-e7ff-11ee-b5de-025e9f07eba1",
        label: "ActewAGL",
      },
      {
        value: "923d0a5f-e7ff-11ee-b5de-025e9f07eba1",
        label: "AGL",
      },
      {
        value: "923d0a69-e7ff-11ee-b5de-025e9f07eba1",
        label: "Alinta Energy",
      },
      {
        value: "923d0a73-e7ff-11ee-b5de-025e9f07eba1",
        label: "Amber",
      },
      {
        value: "923d0a83-e7ff-11ee-b5de-025e9f07eba1",
        label: "Arc Energy Group",
      },
      {
        value: "923d0a8e-e7ff-11ee-b5de-025e9f07eba1",
        label: "Aurora Energy",
      },
      {
        value: "923d0a97-e7ff-11ee-b5de-025e9f07eba1",
        label: "BlueNRG",
      },
      {
        value: "923d0aa2-e7ff-11ee-b5de-025e9f07eba1",
        label: "Brighte Energy",
      },
      {
        value: "923d0aab-e7ff-11ee-b5de-025e9f07eba1",
        label: "Circular Energy",
      },
      {
        value: "923d0ab5-e7ff-11ee-b5de-025e9f07eba1",
        label: "CovaU",
      },
      {
        value: "923d0abe-e7ff-11ee-b5de-025e9f07eba1",
        label: "Diamond Energy",
      },
      {
        value: "923d0ac8-e7ff-11ee-b5de-025e9f07eba1",
        label: "Discover Energy",
      },
      {
        value: "923d0ad1-e7ff-11ee-b5de-025e9f07eba1",
        label: "Dodo Power and Gas",
      },
      {
        value: "923d0add-e7ff-11ee-b5de-025e9f07eba1",
        label: "Electricity in a Box",
      },
      {
        value: "923d0aef-e7ff-11ee-b5de-025e9f07eba1",
        label: "Energy Locals",
      },
      {
        value: "923d0ae6-e7ff-11ee-b5de-025e9f07eba1",
        label: "EnergyAustralia",
      },
      {
        value: "923d0af8-e7ff-11ee-b5de-025e9f07eba1",
        label: "Ergon Energy",
      },
      {
        value: "923d0b04-e7ff-11ee-b5de-025e9f07eba1",
        label: "Future X Power",
      },
      {
        value: "923d0b0d-e7ff-11ee-b5de-025e9f07eba1",
        label: "GEE Energy",
      },
      {
        value: "923d0b17-e7ff-11ee-b5de-025e9f07eba1",
        label: "GloBird Energy",
      },
      {
        value: "923d0b1f-e7ff-11ee-b5de-025e9f07eba1",
        label: "Glow Power",
      },
      {
        value: "923d0b29-e7ff-11ee-b5de-025e9f07eba1",
        label: "Kogan Energy",
      },
      {
        value: "923d0b31-e7ff-11ee-b5de-025e9f07eba1",
        label: "Locality Planning Energy (LPE)",
      },
      {
        value: "923d0b3d-e7ff-11ee-b5de-025e9f07eba1",
        label: "Lumo Energy",
      },
      {
        value: "923d0b46-e7ff-11ee-b5de-025e9f07eba1",
        label: "Momentum Energy",
      },
      {
        value: "923d0b50-e7ff-11ee-b5de-025e9f07eba1",
        label: "Nectr",
      },
      {
        value: "923d0b57-e7ff-11ee-b5de-025e9f07eba1",
        label: "Next Business Energy",
      },
      {
        value: "923d0b63-e7ff-11ee-b5de-025e9f07eba1",
        label: "On by Energy Australia",
      },
      {
        value: "923d0b6b-e7ff-11ee-b5de-025e9f07eba1",
        label: "Origin Energy",
      },
      {
        value: "923d0b74-e7ff-11ee-b5de-025e9f07eba1",
        label: "OVO Energy",
      },
      {
        value: "923d0b7b-e7ff-11ee-b5de-025e9f07eba1",
        label: "Pacific Blue Retail",
      },
      {
        value: "923d0b87-e7ff-11ee-b5de-025e9f07eba1",
        label: "Powershop",
      },
      {
        value: "923d0b8f-e7ff-11ee-b5de-025e9f07eba1",
        label: "Radian Energy",
      },
      {
        value: "923d0b99-e7ff-11ee-b5de-025e9f07eba1",
        label: "ReAmped Energy",
      },
      {
        value: "923d0ba1-e7ff-11ee-b5de-025e9f07eba1",
        label: "Red Energy",
      },
      {
        value: "923d0bab-e7ff-11ee-b5de-025e9f07eba1",
        label: "Simply Energy",
      },
      {
        value: "923d0bb3-e7ff-11ee-b5de-025e9f07eba1",
        label: "Smart Energy",
      },
      {
        value: "923d0bbd-e7ff-11ee-b5de-025e9f07eba1",
        label: "Sonnen",
      },
      {
        value: "923d0bc5-e7ff-11ee-b5de-025e9f07eba1",
        label: "Sumo",
      },
      {
        value: "923d0bce-e7ff-11ee-b5de-025e9f07eba1",
        label: "Tango Energy",
      },
    ],
  };
};
